import React, { Component } from 'react';
import Container from '../../../../components/Container'

import './index.scss';

import oleConsignado from '../../../../assets/lawyers/oleConsignado.png'
import raizen from '../../../../assets/lawyers/raizen.png'

class Depositions extends Component {
  state = {
    selected: 0,
    intervalId: '',
    clients: [
      { lawFirms: '11', negotiatedCases: '6500+', deals: '4000+', text: 'O Com Acordo veio para mudar - para melhor - a gestão dos nossos processos com o perfil de acordo. Passamos a ter acesso direto às negociações dos parceiros e conseguimos monitorar as causas de sucesso e insucesso, permitindo ajustes mais rápidos em nossas políticas e agregando muito mais valor às nossas entregas. Sem dúvidas foi uma parceria de sucesso para a Olé.', name: 'Matheus Nasser', company: 'Gerente Jurídico, Olé Consignado', photo: oleConsignado },
      { lawFirms: '5', negotiatedCases: '700+', deals: '500+', text: 'Nossa parceria com o Com Acordo tem gerado resultados incríveis. Começamos pela área de consumidor e depois desenvolvemos um projeto para a área trabalhista no qual o Com Acordo é parte fundamental. Nossa expectativa é expandir o uso da ferramenta para outras áreas, reduzindo judicialização e custos do contencioso.', name: 'Yve Carpi de Souza', company: 'Diretora Jurídica, Raizen', photo: raizen }
    ]
  }

  componentDidMount() {
    this.interval()
  }

  componentWillUnmount() {
    const { intervalId } = this

    clearInterval(intervalId)
  }

  playDepositions = () => {
    const { selected, clients } = this.state

    if (selected + 1 === clients.length) {
      this.setState({ selected: 0 })
    }
    else {
      this.setState({ selected: selected + 1 })
    }
  }

  interval = () => {
    this.intervalId = setInterval(() => {
      this.playDepositions()
    }, 10000)
  }

  changeDeposition = (deposition) => {
    const { intervalId, interval } = this

    this.setState({ selected: deposition })
    clearInterval(intervalId)
    interval()
  }

  render() {
    const { selected, clients } = this.state
    const { changeDeposition } = this

    return (
      <div className='depositions' id="Depositions">
        <div className='depositions__background'>
        </div>
        <div className='depositions__header'>
          <Container><h3>Depoimentos</h3></Container>
        </div>
        {
          clients.map((client, idx) => {
            if (idx === selected) {
              return (
                <div className='depositions__content' key={idx}>
                  <Container>
                    <div className='depositions__content__infos'>
                      <div className='depositions__metrics'>
                        <span>
                          <h2>{client.lawFirms}</h2>
                          <h3>Escritórios</h3>
                        </span>
                        <span>
                          <h2>{client.negotiatedCases}</h2>
                          <h3>Casos Inseridos</h3>
                        </span>
                        <span>
                          <h2>{client.deals}</h2>
                          <h3>Casos Negociados</h3>
                        </span>
                      </div>
                      <p className='depositions__text'>
                        "{client.text}"
                      </p>
                      <div className='depositions__owner'>
                        <span>{client.company}</span>
                        <span>{client.name}</span>
                      </div>
                    </div>
                    <div className='depositions__content__img'>
                      <img src={client.photo} alt="Cliente" />
                    </div>
                  </Container>
                </div>
              )
            }
            return null
          })
        }
        <div className='depositions__footer'>
          <Container>
            <svg onClick={() => changeDeposition(0)} className={selected === 0 ? 'depositions__footer__dots depositions__footer__dots--selected' : 'depositions__footer__dots'} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle r="6" transform="matrix(-1 0 0 1 6 6)" />
            </svg>
            <svg onClick={() => changeDeposition(1)} className={selected === 1 ? 'depositions__footer__dots depositions__footer__dots--selected' : 'depositions__footer__dots'} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle r="6" transform="matrix(-1 0 0 1 6 6)" />
            </svg>
          </Container>
        </div>
      </div>
    )
  }
}

export default Depositions
